import { Action } from 'typescript-fsa';
import { parentDidNavigate } from '../../actions/ui';
import * as CaseActions from '../../actions/cases.action';
import authSubscriptions from '../../core/authentication-channel/child-window-subscriptions';

const subscriptions: CMx.ChannelSubscription[] = [...authSubscriptions];

const buildSubscriptions = (url: URL) => {
  const id = url.searchParams.get('caseId');
  let caseId = id === null ? Number.NEGATIVE_INFINITY : parseInt(id);

  const caseJsonActions = new Set<string>([
    `${CaseActions.navigateDetail.async.done}`
  ]);

  subscriptions.push({
    match: (message: Action<any>) => {
      return message.payload && caseJsonActions.has(message.type);
    },
    transform: (message: Action<any>) => {
      const sameCase = caseId === message.payload?.result?.case_id;
      return parentDidNavigate(sameCase);
    }
  });
  return subscriptions;
};

export { buildSubscriptions };
